import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { GestionCorreosRepository } from './gestion-correos.repository';
import { EnvioCorreoDraftRequest, getCorreoHistoricoRequest } from './domain/gestion-correos.request';
import { D_CorreoHistoricoResponse, D_SendCorreoDraftResponse } from './domain/gestion-correos.response';



@Injectable({
  providedIn: 'root'
})
export class GestionCorreosService extends GestionCorreosRepository {

  constructor(
    private readonly http: HttpClient,
    private readonly service: GestionCorreosRepository
  ) {
    super();
  }

  override obtenerCorreoHistorico(request: getCorreoHistoricoRequest): Observable<D_CorreoHistoricoResponse> {
    return this.http.post<D_CorreoHistoricoResponse>(`${environment.PATH_API}/integracion/getCorreoHistorico`, request)
  }

  override envioCorreoDraft(prolrequest: EnvioCorreoDraftRequest): Observable<D_SendCorreoDraftResponse> {
    return this.http.post<D_SendCorreoDraftResponse>(`${environment.PATH_API}/integracion/envioCorreoDraft`, prolrequest);
  }

}
